// Catalog media bundle (video, audio, digital, new releases)
import '../css/pages/catalog/video-streams/index.css';
import '../css/pages/catalog/video-streams/list.css';
import '../css/pages/catalog/audio-clips/index.css';
import '../css/pages/catalog/digital-book/index.css';
import '../css/pages/catalog/digital-resource/index.css';
import '../css/pages/catalog/new-releases/index.css';

import { runLegacy } from './helpers/load-legacy';
import mediaelementJs   from '../js/vendor/mediaelement/mediaelement-and-player.min.js?legacy';
import fileDownloadJs   from '../js/vendor/jquery.fileDownload.js?legacy';
import videoStreamsJs   from '../js/pages/catalog/video-streams/list.js?legacy';
import newReleasesJs    from '../js/pages/catalog/new-releases/index.js?legacy';
import digitalBookJs    from '../js/pages/catalog/digital-book/book.js?legacy';
import audioClipsJs     from '../js/pages/catalog/audio-clips/list.js?legacy';

runLegacy(
    mediaelementJs,
    fileDownloadJs,
    videoStreamsJs,
    newReleasesJs,
    digitalBookJs,
    audioClipsJs,
);
